import Component from '../../common/Component';

export default class BannerModal extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = false;
    this.webBanner = [];
    this.mobileBanner = [];
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.getWebBannerData();
    this.getMobileBannerData();
  }

  view() {
    if (this.hidden) return null;

    return <div>
      {this.getWebModal()}
      {this.getMobileModal()}
    </div>;
  }

  getWebModal() {
    if (this.webBanner.length == 0) return null
    return (<div class='banner-modal web'>
      <div class='banner-modal-container'>
        <img src="https://www.rencai.ph/source/img/yuncloseicon.png" alt="quit" class="fa banner close" onclick={this.closePop.bind(this)}></img>
        <img src={this.webBanner[0].img} onclick={this.openUrl.bind(this, this.webBanner[0].url)} />
      </div>
    </div>);
  }
  getMobileModal() {
    if (this.mobileBanner.length == 0) return null
    return (<div class='banner-modal mobile'>
      <div class='banner-modal-container'>
        <img src="https://www.rencai.ph/source/img/yuncloseicon.png" alt="quit" class="fa banner close" onclick={this.closePop.bind(this)}></img>
        <img src={this.mobileBanner[0].img} onclick={this.openUrl.bind(this, this.mobileBanner[0].url)} />
      </div>
    </div>);
  }


  items() {
    const items = new ItemList();
    return items;
  }

  closePop() {
    this.hidden = true;
  }

  getWebBannerData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.banner['forum_popup'];

      if (list) {
        this.webBanner = list;
      }
    }
  }
  getMobileBannerData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.banner['mobile_forum_popup'];

      if (list) {
        this.mobileBanner = list;
      }
    }
  }

  openUrl(url) {
    if (url != "")
      window.open(url);
  }
}
